(function () {
  const callbacks = [];
  let accepted = false;

  function accept() {
    if (accepted) return;
    accepted = true;

    document.querySelectorAll('.google-map-consent').forEach(function (placeholder) {
      placeholder.remove();
    });

    callbacks.forEach(function (callback) {
      callback();
    });
    callbacks.length = 0;
  }

  window.googleMapConsent = {
    onAccept: function (callback) {
      if (accepted || !document.querySelector('.google-map-consent')) {
        callback();
        return;
      }
      callbacks.push(callback);
    }
  };

  document.addEventListener('click', function (event) {
    if (event.target.closest('.google-map-consent__button')) accept();
  });
})();
